import React, { useEffect, useState } from "react";
import BasicDetailsCp from "./BasicDetailsCp";
import ReferenceDetailsForm from "./ReferenceDetailsForm";
import OthersDetailsCp from "./OthersDetailsCp";
import DirectorInfo from "./DirectorInfo";
import { useDispatch, useSelector } from "react-redux";
import {
  clearProcessData,
  setCurrentMembership,
  setProcessData,
} from "../../redux/actions/processAction";
import { useNavigate, useParams } from "react-router-dom";
import { GetMembershipList, getUserDetails } from "../../api/common";
import moment from "moment";
import { removeNullValues } from "../../utils/commonFunction";
import { store } from "../../redux/store";

export default function AdminMembershipForm() {
  const { user_id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(1);
  const [invalidForm, setInValidForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const { currentMembership } = useSelector((state) => state.process);
  const { data } = useSelector((state) => state.process);
  const [isDataUpated, setIsDataUpdated] = useState(false);

  /* tabs nav */
  const tabs =
    currentMembership?.name.toString().toLowerCase() === "star"
      ? [
          { id: 1, label: "Basic Details" },
          { id: 3, label: "Membership Details" },
          { id: 4, label: "Other Details" },
        ]
      : [
          { id: 1, label: "Basic Details" },
          { id: 2, label: "Director Information" },
          { id: 3, label: "Membership Details" },
          { id: 4, label: "Other Details" },
        ];

  const handleBack = () => {
    const isStarMembership = currentMembership?.name.toLowerCase() === "star";
    if (currentTab > 1) {
      setCurrentTab(
        (prevTab) => prevTab - (isStarMembership && currentTab === 3 ? 2 : 1)
      );
    } else {
      navigate("/admin/user/select-membership", { replace: true });
      dispatch(setCurrentMembership(null));
    }
  };

  const handleNext = () => {
    // const appId = data.app_id || data.plan_history?.app_id;
    const isStarMembership = currentMembership?.name.toLowerCase() === "star";

    // if (currentTab === tabs.length) {
    //     navigate(`/admin/user/application-review/${btoa(appId)}`, { replace: true });
    // } else {
    // }
    setCurrentTab(
      (prevTab) => prevTab + (isStarMembership && currentTab === 1 ? 2 : 1)
    );
  };

  const handleTab = (tab) => {
    setCurrentTab(tab);
  };

  const getUserData = async () => {
    setLoading(true);
    try {
      const uid = atob(user_id);
      const res = await getUserDetails(uid);
      if (res.status === 200) {
        const respData = res.data.data;
        if (uid === data.id) {
          dispatch(
            setProcessData({
              ...removeNullValues(respData.plan_history),
              ...removeNullValues(respData),
              ...removeNullValues(data),
              incorporation_date: data.incorporation_date
                ? data.incorporation_date
                : respData.org_type === "company"
                ? moment(respData.company.incorporation_date).format(
                    "YYYY-MM-DD"
                  )
                : respData.org_type === "partnership"
                ? moment(respData.llp.incorporation_date).format("YYYY-MM-DD")
                : "",
              director: data.director
                ? typeof data.director === "string"
                  ? JSON.parse(data.director)
                  : data.director
                : respData.director
                ? JSON.parse(respData.director).filter(
                    (item) => item.name || item.mobile_number || item.email
                  )
                : [{ name: "", mobile_number: "", email: "" }],
              app_id:
                respData.plan_history && respData.plan_history.app_id
                  ? respData.plan_history.app_id
                  : null,
              email_verified: data.email === respData.email ? true : false,
              mobile_verified:
                data.mobile_number.toString() ===
                respData.mobile_number.toString()
                  ? true
                  : false,
            })
          );
        } else {
          dispatch(
            setProcessData({
              ...data,
              ...respData.plan_history,
              ...respData,
              incorporation_date:
                respData.org_type === "company"
                  ? moment(respData.company.incorporation_date).format(
                      "YYYY-MM-DD"
                    )
                  : respData.org_type === "partnership"
                  ? moment(respData.llp.incorporation_date).format("YYYY-MM-DD")
                  : "",
              director: data.director
                ? typeof data.director === "string"
                  ? JSON.parse(data.director)
                  : data.director
                : respData.director
                ? JSON.parse(respData.director).filter(
                    (item) => item.name || item.mobile_number || item.email
                  )
                : [{ name: "", mobile_number: "", email: "" }],
              app_id:
                respData.plan_history && respData.plan_history.app_id
                  ? respData.plan_history.app_id
                  : null,
              email_verified: true,
              mobile_verified: true,
            })
          );
        }

        const memRes = await GetMembershipList();
        if (memRes.status === 200 && memRes.data.success) {
          const list = memRes.data.data;
          const currentMem = list.find(
            (item) => item.id === respData.plan_history.plan_id
          );
          dispatch(setCurrentMembership(currentMem));
        }
      }
    } catch (error) {
      dispatch(setCurrentMembership(null));
      dispatch(setProcessData({}));
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user_id) {
      getUserData();
    }
  }, [isDataUpated]); //eslint-disable-line

  useEffect(() => {
    store.dispatch(clearProcessData());
    setIsDataUpdated(true);
  }, []); // eslint-disable-line

  return (
    <>
      <div className="customContainer">
        <div className="headingTexts ">
          <h2>Membership Form</h2>
          <p>
            you are applying under{" "}
            <span style={{ fontWeight: "600" }}>
              {currentMembership?.name && !loading
                ? currentMembership?.name
                : ""}{" "}
              Membership
            </span>
          </p>
        </div>

        <nav
          className={
            "tabMenu " +
            (currentMembership?.name.toString().toLowerCase() === "star"
              ? "starMenu"
              : "")
          }
        >
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            {!loading &&
              tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`nav-link ${
                    tab.id === currentTab ? "active" : ""
                  }`}
                  id={`${tab.id}-tab`}
                  type="button"
                  role="tab"
                  onClick={() => handleTab(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div className={"tab-pane fade show active"} role="tabpanel">
            {currentTab === 1 && !loading && (
              <BasicDetailsCp
                invalidForm={invalidForm}
                setInValidForm={setInValidForm}
                handleTab={handleTab}
                handleBack={handleBack}
                handleNext={handleNext}
              />
            )}
            {currentTab === 2 && !loading && (
              <DirectorInfo
                invalidForm={invalidForm}
                setInValidForm={setInValidForm}
                handleTab={handleTab}
                handleBack={handleBack}
                handleNext={handleNext}
              />
            )}
            {currentTab === 3 && !loading && (
              <ReferenceDetailsForm
                invalidForm={invalidForm}
                setInValidForm={setInValidForm}
                handleTab={handleTab}
                handleBack={handleBack}
                handleNext={handleNext}
              />
            )}
            {currentTab === 4 && !loading && (
              <OthersDetailsCp
                invalidForm={invalidForm}
                setInValidForm={setInValidForm}
                handleTab={handleTab}
                handleBack={handleBack}
                handleNext={handleNext}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
